import icEdit from "assets/images/ic-edit-04.svg";
import icEyeOpen from "assets/images/ic-eye-open.svg";
import icTrash01Red from "assets/images/ic-trash-01-red.svg";
import Badge from "components/commons/badge";
import Button from "components/commons/button";
import { ACTION_TYPE } from "constants/constant";

export const INITIAL_DATA_QUERY = {
    page: 1,
    limit: 20,
    search: ''
}

export const TABLE_HAPPINESS_INDEX_LIST = {
    name: 'Data Happiness Index',
    column: [
        {
            name: "Periode Survey",
            key: "period",
            className: "font-bold capitalize"
        },
        {
            name: "Total Responden",
            key: "total_respondents",
            classNameHeader: "!text-center",
            className: "text-center",
            sortable: true
        },
        {
            name: "Happiness Index Company",
            key: "company_happiness_index",
            classNameHeader: "!text-center",
            className: "text-center",
            sortable: true,
            render: ({value}) => `${value}%`
        },
        {
            name: "Happiness Index People & Culture",
            key: "pnc_happiness_index",
            classNameHeader: "!text-center",
            className: "text-center",
            sortable: true,
            render: ({value}) => `${value}%`
        },
        {
            name: "Happiness Index Finance",
            key: "finance_happiness_index",
            classNameHeader: "!text-center",
            className: "text-center",
            sortable: true,
            render: ({value}) => `${value}%`
        },
        {
            name: "Status",
            key: "status",
            render: ({value}) => value ? <Badge title={value} type={value?.toLowerCase()}/> : ''
        },
        {
            name: "Action",
            key: "action",
            classNameHeader: "!text-center",
            render: ({item, onClickItem}) => (
                <div className="flex space-x-4 justify-center">
                    <Button
                        className="w-[80px]" 
                        type="outline"
                        icon={icEyeOpen}
                        title="Detail"
                        onClick={() => onClickItem({item, actionType: ACTION_TYPE.DETAIL})}
                    />
                    <Button
                        type="danger"
                        icon={icTrash01Red}
                        disabled={item.status === 'submitted'}
                        onClick={() => onClickItem({item, actionType: ACTION_TYPE.DELETE})}
                    />
                </div>
            )
        }
    ]
}

export const INITIAL_DATA_QUERY_HAPPINESS_INDEX_DETAIL = {
    page: 1,
    limit: 20,
    search: ''
}

export const DEFAULT_FORM_HAPPINESS_INDEX = {
    department_name: null,
    total_respondents: null,
    company_happiness_index: null,
    finance_happiness_index: null,
    pnc_happiness_index: null 
}

export const HAPPINESS_INDEX_VALIDATION = {
    company_happiness_index: {
        maximumValue: {
            value: 100,
            message: 'value must be less than or equal to 100'
        },
    },
    finance_happiness_index: {
        maximumValue: {
            value: 100,
            message: 'value must be less than or equal to 100'
        },
    },
    pnc_happiness_index: {
        maximumValue: {
            value: 100,
            message: 'value must be less than or equal to 100'
        },
    }
}


export const TABLE_HAPPINESS_INDEX_DETAIL = {
    name: 'Data Happiness Index',
    column: [
        {
            name: "Periode Survey",
            key: "period",
            className: "font-bold capitalize"
        },
        {
            name: "Department",
            key: "department_name",
            className: "font-bold capitalize"
        },
        {
            name: "Total Responden",
            key: "total_respondents",
            classNameHeader: "!text-center",
            className: "text-center"
        },
        {
            name: "Happiness Index Company",
            key: "company_happiness_index",
            classNameHeader: "!text-center",
            className: "text-center",
            render: ({value}) => `${value}%`
        },
        {
            name: "Happiness Index People & Culture",
            key: "pnc_happiness_index",
            classNameHeader: "!text-center",
            className: "text-center",            
            render: ({value}) => `${value}%`
        },
        {
            name: "Happiness Index Finance",
            key: "finance_happiness_index",
            classNameHeader: "!text-center",
            className: "text-center",
            render: ({value}) => `${value}%`
        },
    ]
}

export const TABLE_HAPPINESS_INDEX_IMPORT_DATA = {
    ...TABLE_HAPPINESS_INDEX_DETAIL,
    column: [
        ...TABLE_HAPPINESS_INDEX_DETAIL.column,
        {
            name: "Action",
            key: "action",
            classNameHeader: "!text-center",
            render: ({item, onClickItem}) => (
                <div className="flex space-x-4 justify-center">
                    <Button 
                        icon={icEdit} 
                        type="outline"
                        onClick={() => onClickItem({item, actionType: ACTION_TYPE.EDIT})}
                    />
                    <Button
                        type="danger"
                        icon={icTrash01Red}
                        onClick={() => onClickItem({item, actionType: ACTION_TYPE.DELETE})}
                    />
                </div>
            )
        }

    ]
}


export const TABLE_HAPPINESS_INDEX_IMPORT = [
    {
        name: "Department",
        key: "department_name",
        className: "font-bold capitalize"
    },
    {
        name: "Total Responden",
        key: "total_respondents",
        className: "font-bold capitalize",
    },
    {
        name: "% Happiness Index Company",
        key: "company_happiness_index",
        className: "font-bold capitalize",
    },
    {
        name: "% Happiness Index People & Culture",
        key: "pnc_happiness_index",
        className: "font-bold capitalize",
    },
    {
        name: "% Happiness Index Finance",
        key: "finance_happiness_index",
        className: "font-bold capitalize",
    },
    {
        name: 'Status',
        key: 'status',
        width: 250,
        render: () => <Badge title='invalid' type='invalid'/>
    },
]

